import {gql} from '@apollo/client'

export const GET_PAYMENTS = gql`
  query GetPayments(
    $q: String
    $state: String
    $fromDate: String
    $toDate: String
    $page: Int
    $limit: Int
    $sortBy: String
    $sortDirection: String
  ) {
    payments(
      q: $q
      state: $state
      fromDate: $fromDate
      toDate: $toDate
      page: $page
      limit: $limit
      sortBy: $sortBy
      sortDirection: $sortDirection
    ) {
      collection {
        id
        date
        amount
        state
        description
        importCode
        importDetails
        importParticulars
        importReference
        xeroLink
        isDuplicate
        account {
          id
          displayName @client
          contactFullName @client
          name
          contactFirstName
          contactLastName
          customerNumber
        }
      }
      metadata {
        totalCount
      }
    }
  }
`

export const UPDATE_PAYMENTS = gql`
  mutation UpdatePayments($paymentIds: [String!]!, $state: String, $ignoredAt: String, $organisationId: ID) {
    payments(paymentIds: $paymentIds, state: $state, ignoredAt: $ignoredAt, organisationId: $organisationId) {
      collection {
        id
        state
        bankImport {
          id
        }
      }
    }
  }
`
